import { classnames } from 'Utils/classnames/classnames.utils';

export const themes = ({
  isExclusiveCollection = false,
  isScrollable = false,
  reverseLabelAndNumber = true,
} = {}) => ({
  default: {
    thRoot: 'flex flex-wrap -m-1',
    thButton:
      'cursor-pointer bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
    thButtonActive:
      'cursor-default bg-saffron hocus:bg-saffron capitalize flex flex-1 font-bold gap-10 items-center justify-center m-1 pointer-events-none p-10 text-14 text-black transition-bg-color duration-250 ease-in w-full',
    thIcon: '',
    thIconLgSize: '3.25rem',
    thIconSize: '1.625rem',
    thText: 'text-initial',
    thNumber: 'block leading-1',
  },
  overlay: {
    thRoot: classnames('flex gap-10', {
      'mt-auto flex-wrap justify-center': !isScrollable,
      'mt-auto overflow-x-scroll sm:overflow-hidden': isScrollable,
    }),
    thButton:
      'bg-white hocus:bg-white-active capitalize cursor-pointer flex font-bold gap-5 items-center justify-center px-20 py-10 rounded-pill text-12 text-black hocus:text-black-active duration-250 ease-in transition-all',
    thButtonActive:
      'cursor-default bg-black/60 capitalize flex font-bold gap-5 items-center justify-center px-20 py-10 pointer-events-none rounded-pill text-12 text-white duration-250 ease-in transition-all',
    thIcon: 'shrink-0 overflow-visible',
    thIconLgSize: '3rem',
    thIconSize: '1.5rem',
    thText: `flex ${
      reverseLabelAndNumber ? 'flex-row-reverse ' : ''
    } font-bold justify-between w-full text-initial`,
    thNumber: 'ps-5',
  },
  overlayCompact: {
    thRoot: classnames('lg:hidden', {
      'mt-auto flex flex-wrap justify-center rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active':
        !isScrollable,
      'mt-auto flex overflow-x-scroll rounded-12 bg-white p-5 text-black transition-all hocus:bg-white-active hocus:text-black-active sm:overflow-hidden':
        isScrollable,
    }),
    thButton: 'text-inherit leading-none mx-5',
    thButtonActive: 'text-inherit leading-none',
    thIcon: 'shrink-0 overflow-visible align-middle',
    thIconLgSize: '3rem',
    thIconSize: '1rem',
    thText: '',
    thHideLabel: true,
    thOverrideMinWidth: true,
    thNumber: '',
  },
  accommodation: {
    thRoot: `divide-y md:divide-x flex flex-col md:flex-row h-full justify-center overflow-hidden border-1 border-t-0 border-${
      isExclusiveCollection ? 'ultramarine' : 'lightGrey'
    } rounded-b-12 w-full`,
    thButton:
      'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
    thButtonActive:
      'flex gap-5 w-full items-center justify-center grow cursor-pointer bg-white capitalize font-bold p-10 text-14',
    thIcon: `overflow-visible text-${isExclusiveCollection ? 'ultramarine' : 'black'}`,
    thIconLgSize: '4rem',
    thIconSize: '2rem',
    thText: 'font-bold text-initial text-black duration-250 ease-in transition-all',
    thNumber: 'ps-5',
  },
});
